<template>
  <div id="policy">
    <el-tabs style="min-height:800px" type="border-card" v-model="tab">
      <el-tab-pane :label=" type==1? '实验室规章制度':'政策法规'" name="1"></el-tab-pane>
      <div>
        <el-table :data="file_list" border style="width: 100%">
          <el-table-column align="center" prop="file_name" label="名称" width="180"></el-table-column>
          <el-table-column align="center" prop="create_date" label="上传日期" width="180"></el-table-column>
          <el-table-column align="center" prop="name" label="上传人" width="180"></el-table-column>
          <el-table-column align="center" prop="down_number" label="下载次数" width="180"></el-table-column>
          <el-table-column align="center" prop="address" label="操作">
            <template slot-scope="scope">
              <span>
                <el-link :underline="false" @click="del(scope.row.id)">删除</el-link>
              </span>
              <span style="margin-left:20px">
                <el-link :underline="false" @click="download(scope.row.id)">下载</el-link>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:20px">
          <span style="cursor: pointer;">
            <el-upload
              align
              class="upload-demo"
              ref="upload"
              action="https://www.baidu.com"
              :on-change="handlePreview"
              :file-list="fileList"
              :auto-upload="false"
              :limit="1"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                style="background-color:white;color:#606266;border:0px"
              >
                <span style="margin-right:5px">
                  <i class="fas fa-plus-square fa-lg"></i>
                </span>
                {{type==1?'上传规章制度':'上传政策法规'}}
              </el-button>
              <el-button
                style="margin-left: 10px;"
                size="small"
                type="success"
                @click="submitUpload"
              >提交</el-button>
              <div slot="tip" class="el-upload__tip">可以上传excel/word/pdf文件，且不超过500kb</div>
            </el-upload>
          </span>
        </div>
      </div>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      tab: "1",
      file_list: [],
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      fileList: [],
      type: this.$route.params.type
    };
  },
  created() {
    this.get_policy_list();
  },
  activated() {
    if (this.type == 1) {
      this.$store.state.user_location = "实验室规章制度";
    } else {
      this.$store.state.user_location = "政策法规";
    }
  },
  methods: {
    submitUpload() {
      let formData = new FormData();
      formData.append("mobile", this.mobile);
      formData.append("token", this.token);
      formData.append("file", this.file);
      if (this.type == 2) {
        formData.append("harmful", "1");
      }
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios
        .post(
          this.serve + "/personal/upload_policy",
          formData,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.get_policy_list();
            this.$message({
              showClose: true,
              type: "success",
              message: "上传成功",
              offset: 400
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
              offset: 400
            });
          }
        });
    },
    handleRemove(file, fileList) {
      this.file = {};
    },
    handlePreview(file) {
      this.file = file.raw;
    },
    download(id) {
      this.axios
        .get(this.serve + "/personal/download_policy", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "error") {
            this.$message({
              showClose: true,
              type: "error",
              message: "下载失败",
              offset: 400
            });
          } else {
            this.get_policy_list();
            window.location.href =
              this.serve + "/personal/download_policy2?mobile=" +
              this.mobile +
              "&token=" +
              this.token +
              "&id=" +
              id;
          }
        });
    },
    del(id) {
      this.axios
        .get(this.serve + "/personal/del_policy", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            let n;
            for (n in this.file_list) {
              if (this.file_list[n].id == id) {
                this.file_list.splice(n, 1);
              }
            }
            this.$message({
              showClose: true,
              type: "success",
              message: "删除成功",
              offset: 400
            });
          } else {
          }
        });
    },
    get_policy_list() {
      if (this.type == 2) {
        var params = {
          mobile: this.mobile,
          token: this.token,
          harmful: 1
        };
      } else {
        var params = {
          mobile: this.mobile,
          token: this.token
        };
      }
      this.axios
        .get(this.serve + "/personal/get_policy", {
          params: params
        })
        .then(res => {
          if (res.data.status == "success") {
            let data = res.data.data;
            let n;
            for (n in data) {
              data[n].create_date = this.formatTime(
                data[n].create_date,
                "Y-M-D h:m:s"
              );
            }
            this.file_list = data;
          }
        });
    },
    formatTime(number, format) {
      var formateArr = ["Y", "M", "D", "h", "m", "s"];
      var returnArr = [];

      var date = new Date(number * 1000);
      returnArr.push(date.getFullYear());
      returnArr.push(this.formatNumber(date.getMonth() + 1));
      returnArr.push(this.formatNumber(date.getDate()));

      returnArr.push(this.formatNumber(date.getHours()));
      returnArr.push(this.formatNumber(date.getMinutes()));
      returnArr.push(this.formatNumber(date.getSeconds()));

      for (var i in returnArr) {
        format = format.replace(formateArr[i], returnArr[i]);
      }
      return format;
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    }
  }
};
</script>

<style lang="scss">
#policy {
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border-top: 3px solid #f5f7fa;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 3px solid #e2211c;
  }
}
</style>
